// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1KWAs","options":"AnswerScale_options__8Q5p-","selected":"AnswerScale_selected__1v1LS"};